import React from 'react';
import { DataListModel } from './DataListModel';
import { ListModel, RadioInputWrapper, NotResults } from './styled';

interface Props {
  dataList: DataListModel[];
  handleClickItem?: Function;
  activeItem?: number;
  handleChange?: Function;
  showFirstItems?: number;
  className?: string;
  message?: string;
  activeColor?: string;
}

export const PredictiveResultsModal: React.FC<Props> = ({
  dataList,
  handleChange,
  activeItem,
  showFirstItems,
  className,
  message,
  activeColor
}) => {

  const getText = (ubigeo: string) => ubigeo ? `, ${ubigeo}` : '';

  const createElement = (district?: string, province?: string, department?: string) => {
    const element =  `<span>${district}</span>${getText(province)}${getText(department)}`;
    return element;
  };

  const setUrbanizationOrDistrict = (data) => {
    const initial = data.id.charAt(0);
    if (initial === 'D') {
      return data.district_name
    }
    return data.urbanization_name
  };

  const setDistrictOrProvince = (data) => {
    const initial = data.id.charAt(0);
    if (initial === 'D') {
      return data.province_name
    }
    return data.district_name
  };

  return (
    <ListModel showFirstItems={showFirstItems} className={className}>
      {
        dataList && dataList.length > 0 && dataList.map((element, index) => (
          <RadioInputWrapper
            name="ubigeo"
            key={index}
            data-index={index}
            tabIndex="-1"
            activeSuggestion={index === activeItem ? true : false}
            value={element.data.district_alias}
            contentLeft
            colorActive={activeColor}
            checked={index === activeItem ? true : false}
            handleChange={value => handleChange(value, index)}
          >
            <p dangerouslySetInnerHTML={
              {
                __html: createElement(
                  setUrbanizationOrDistrict(element.data),
                    setDistrictOrProvince(element.data),
                    element.data.department_name
                )
              }} />
          </RadioInputWrapper>
        ))
      }
      { message && <NotResults   dangerouslySetInnerHTML={{
                __html: 'No se encontraron resultados.'
              }} />}
    </ListModel>
)};

PredictiveResultsModal.defaultProps = {
  showFirstItems: 2
}
